hls.js runtime vendor bundle; original source map is not shipped.